/**
 * Account Management
 * FT-98: Simplified to three tabs only - Profile | Sync | Team
 * Removed Approval Settings and Approval Queue tabs (replaced by FT-06d hardcoded role logic)
 */
import React, { useState } from 'react';
import AccountPage from './account/AccountPage';
import SyncPanel from './sync/SyncPanel';
import {
  User,
  Cloud,
  ArrowLeft,
  Shield
} from 'lucide-react';
import { UserManagementPanel } from './auth/UserManagementPanel';

const VIEWS = {
  ACCOUNT: 'account',
  SYNC: 'sync',
  USERS_MGMT: 'users-mgmt'
};

export const AccountManagement = ({ onBack }) => {
  const [currentView, setCurrentView] = useState(VIEWS.ACCOUNT);

  const renderCurrentView = () => {
    switch (currentView) {
      case VIEWS.ACCOUNT:
        return <AccountPage />;
      case VIEWS.SYNC:
        return <SyncPanel />;
      case VIEWS.USERS_MGMT:
        return <UserManagementPanel />;
      default:
        return <AccountPage />;
    }
  };

  const getActiveTabClass = (view) => {
    return currentView === view
      ? 'border-cyan-500 text-cyan-600'
      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300';
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-4">
              {onBack && (
                <button
                  onClick={onBack}
                  className="p-2 rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-100"
                >
                  <ArrowLeft className="h-5 w-5" />
                </button>
              )}
              <h1 className="text-xl font-semibold text-gray-900">
                Account Management
              </h1>
            </div>
          </div>

          {/* FT-98: Three tabs only - Profile | Sync | Team */}
          <div className="border-b border-gray-200">
            <nav className="-mb-px flex space-x-8">
              <button
                onClick={() => setCurrentView(VIEWS.ACCOUNT)}
                className={`whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm ${getActiveTabClass(VIEWS.ACCOUNT)}`}
              >
                <User className="h-5 w-5 mr-2 inline" />
                Profile
              </button>

              <button
                onClick={() => setCurrentView(VIEWS.SYNC)}
                className={`whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm ${getActiveTabClass(VIEWS.SYNC)}`}
              >
                <Cloud className="h-5 w-5 mr-2 inline" />
                Sync
              </button>

              <button
                onClick={() => setCurrentView(VIEWS.USERS_MGMT)}
                className={`whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm ${getActiveTabClass(VIEWS.USERS_MGMT)}`}
              >
                <Shield className="h-5 w-5 mr-2 inline" />
                Team
              </button>
            </nav>
          </div>
        </div>
      </div>

      {/* Content */}
      <main className="py-8">
        {renderCurrentView()}
      </main>
    </div>
  );
};

export default AccountManagement;
